import { takeEvery, all, select, put } from 'redux-saga/effects';
import {
  APPLY_COMPANY_SORT_ORDER,
  FILTER_DEFAULT_LIMIT,
  REQUEST_COMPANY_FILTER,
  REQUEST_COMPANIES,
  APPLY_COMPANY_FILTER,
  REQUEST_COMPANY_FILTER_RESET,
} from './constants';
import { GET_MY } from '../../containers/App/constants';
import { selectCompanyFilter } from './selectors';
import { makeSelectLocale } from '../../containers/LanguageProvider/selectors';

function* requestCompanyFilter() {
  let filter = yield select(selectCompanyFilter());
  let locale = yield select(makeSelectLocale());

  let offset = filter.offset || 0;
  let limit = filter.limit || FILTER_DEFAULT_LIMIT;
  let text = filter.searchString?.trim() || null;
  const sortType = filter.sortType || undefined;
  const order = filter.order || undefined;

  let path = `company/getList`;

  let searchParams = {
    locale,
    offset,
    limit,
    sortType,
    order,
    text: text ?? undefined,
    filters: filter.properties?.map(f => (f.value?.id ? { ...f, value: [f.value.id + ''] } : f)),
  };

  yield put({
    type: GET_MY,
    id: REQUEST_COMPANIES,
    work: REQUEST_COMPANIES,
    gate: REQUEST_COMPANIES,
    path,
    post: searchParams,
  });
}

export function* companiesSaga() {
  yield all([
    takeEvery(APPLY_COMPANY_FILTER, requestCompanyFilter),
    takeEvery(REQUEST_COMPANY_FILTER, requestCompanyFilter),
    takeEvery(REQUEST_COMPANY_FILTER_RESET, requestCompanyFilter),
    takeEvery(APPLY_COMPANY_SORT_ORDER, requestCompanyFilter),
  ]);
}
